import React, {Component} from "react";
import {Translate} from "react-i18nify";
import {ReactSVG} from "react-svg";

import * as config from "../../../constants/config";
import * as modelHelper from "../../../helpers/modelHelper";
import * as getterHelper from "../../../helpers/getterHelper";
import * as resources from "../../../constants/resources";

import imgBarcode from "../../../resources/img/svgicons/barcode.svg";
import imgDelete from "../../../resources/img/svgicons/delete.svg";
import imgSave from "../../../resources/img/svgicons/save.svg";
import Modal from "../generic/Modal";
import Table, {TABLE_VARIANT_SECONDARY} from "../generic/Table";
import Button from "../generic/Button";

export default class CanisterBarcodeModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeCanister: null
        };
    }

    getColorantByCanister = (canister) => {
        let colorant;
        for (colorant of this.props.colorantList) {
            if (canister.colorant !== null && canister.colorant.name === colorant.name) {
                return colorant;
            }
        }

        return null;
    };

    getCanisterById = (id) => {
        let canister;
        for (canister of this.props.canisterList) {
            if (canister.id === id) {
                return canister;
            }
        }

        return null;
    };

    handleCloseModalClick = () => {
        this.props.closeModal();
    };

    handleCanisterRowClick = (event) => {
        let canister = this.getCanisterById(Number(event.currentTarget.dataset.id));

        if (canister && canister.id !== this.state.activeCanister) {
            this.props.setResetButton();

            this.setState({
                activeCanister: canister.id
            });
        }
    };

    handleDeleteBarcodeClick = () => {
        this.props.setCanisterBarcode(this.state.activeCanister, "");
        this.setState({activeCanister: null});
    };

    handleSaveBarcodeClick = () => {
        this.props.setCanisterBarcode(this.state.activeCanister, this.props.barcode);
        this.setState({activeCanister: null});
    };

    getBarcodeSaveButton = (oldBarcode) => {
        if (this.props.barcode !== "" && this.props.barcode !== oldBarcode) {
            return (
                <button className="btn manual-scan save" onClick={this.handleSaveBarcodeClick}>
                    <ReactSVG alt="save" src={imgSave} />
                </button>
            );
        }

        return "";
    };

    handleManualScanButtonClick = () => {
        this.props.showManualBarcodeScan(true);
    };

    getBarcodeRow = (canister) => {
        let barcode = canister.barcode === null ? "" : canister.barcode;

        if (
            canister.id !== this.state.activeCanister ||
            !this.props.loggedUser.canEdit(resources.FUNCTION_SET_CANISTER_BARCODE)
        ) {
            return (
                <div className="col-xs-6 barcode">
                    <span className="barcode-text">{barcode}</span>
                </div>
            );
        }

        if (this.props.barcode === "" && barcode.length > 0) {
            return (
                <div className="col-xs-6 barcode">
                    <div className="barcode-text">
                        <div>{barcode}</div>
                        <Translate
                            className="barcode-note color-primary"
                            value="customRedlikeSettings.scanOrDeleteCanisterBarcode"
                        />
                    </div>
                    <div className="btn-row">
                        <button className="btn manual-scan scan" onClick={this.handleManualScanButtonClick}>
                            <ReactSVG alt="customers" src={imgBarcode} />
                        </button>
                        <button className="btn manual-scan" onClick={this.handleDeleteBarcodeClick}>
                            <ReactSVG className="btn-icon pull-left" alt="delete" src={imgDelete} />
                        </button>
                    </div>
                </div>
            );
        }

        if (this.props.barcode === "") {
            return (
                <div className="col-xs-6 barcode">
                    <span className="barcode-text color-primary">
                        <Translate value="customRedlikeSettings.scanCanisterBarcode" />
                    </span>
                    <div className="btn-row">
                        <button className="btn manual-scan scan" onClick={this.handleManualScanButtonClick}>
                            <ReactSVG alt="customers" src={imgBarcode} />
                        </button>
                    </div>
                </div>
            );
        }

        return (
            <div className="col-xs-6 barcode">
                <span className="barcode-text">{this.props.barcode === "" ? barcode : this.props.barcode}</span>
                <div className="btn-row">
                    <button className="btn manual-scan scan" onClick={this.handleManualScanButtonClick}>
                        <ReactSVG alt="customers" src={imgBarcode} />
                    </button>
                    {this.getBarcodeSaveButton(barcode)}
                </div>
            </div>
        );
    };

    getCanisterRowActiveClass = (index) => {
        if (
            this.state.activeCanister === index &&
            this.props.loggedUser.canEdit(resources.FUNCTION_SET_CANISTER_BARCODE)
        ) {
            return "col-xs-12 select-color active";
        }

        return "col-xs-12 select-color";
    };

    getCanisterRgb = (canister, colorant) => {
        if (canister !== null && canister.colorant !== null && canister.colorant.rgb !== null) {
            return canister.colorant.rgb;
        }

        if (colorant !== null && colorant.rgb !== null) {
            return colorant.rgb;
        }

        return config.DEFAULT_RGB;
    };

    getCanisterRows = () => {
        let rows = [];
        let canister, colorant, rgb;

        for (canister of this.props.canisterList) {
            if (canister.colorant !== null) {
                colorant = canister.colorant;

                if (colorant.rgb === null) {
                    colorant = this.getColorantByCanister(canister);
                }

                rgb = this.getCanisterRgb(canister, colorant);
                rows.push(
                    <div
                        key={canister.id}
                        className={this.getCanisterRowActiveClass(canister.id)}
                        onClick={this.handleCanisterRowClick}
                        data-id={canister.id}
                    >
                        <div className="col-xs-4 color-codecolor-code">
                            <div
                                className="color-square"
                                style={{
                                    backgroundColor: rgb
                                }}
                            />
                            <div className="col-canister-name">
                                {colorant === null ? canister.colorant.name : colorant.name}
                            </div>
                        </div>
                        <div className="col-xs-2 col-canister-id">{canister.id}</div>
                        {this.getBarcodeRow(canister)}
                    </div>
                );
            }
        }

        return rows;
    };

    handleTableItemClick = (event) => {
        let activeItem = getterHelper.getObjectById(this.props.canisterList, Number(event.currentTarget.dataset.key));
        if (activeItem !== null) {
            this.props.setResetButton();
            this.setState({activeCanister: activeItem.id});
        }
    };

    getTableHeader = () => {
        return modelHelper.buildTableRow([
            modelHelper.buildTableCell(<Translate value="general.canister" />),
            modelHelper.buildTableCell(<Translate value="general.canisterId" />),
            modelHelper.buildTableCell(<Translate value="customRedlikeSettings.barcode" />)
        ]);
    };

    getBarcodeButtons = (record) => {
        return this.state.activeCanister === record.id &&
            this.props.loggedUser.canEdit(resources.FUNCTION_SET_CANISTER_BARCODE) ? (
            <div className="col-5 flex flex-wrap flex-align-center">
                <Button className="margin-left-5" svgBefore={imgBarcode} onClick={this.handleManualScanButtonClick} />
                {(record.barcode && !this.props.barcode) || this.props.barcode === record.barcode ? (
                    <Button className="margin-left-5" svgBefore={imgDelete} onClick={this.handleDeleteBarcodeClick} />
                ) : null}
                {this.props.barcode &&
                this.state.activeCanister === record.id &&
                this.props.barcode !== record.barcode ? (
                    <Button className="margin-left-5" svgBefore={imgSave} onClick={this.handleSaveBarcodeClick} />
                ) : null}
            </div>
        ) : null;
    };

    getBarcodeRowItem = (record) => {
        return (
            <div className="flex flex-wrap">
                <div className="col-7  flex flex-align-center-vertical flex-wrap">
                    {this.props.barcode || record.barcode ? (
                        <span className="col-12" style={{wordBreak: "break-all"}}>
                            {this.props.barcode && this.state.activeCanister === record.id
                                ? this.props.barcode
                                : record.barcode}
                        </span>
                    ) : null}

                    {this.state.activeCanister === record.id &&
                    this.props.loggedUser.canEdit(resources.FUNCTION_SET_CANISTER_BARCODE) ? (
                        record.barcode || this.props.barcode ? (
                            <Translate
                                className="font-size-0_5em"
                                value="customRedlikeSettings.scanOrDeleteCanisterBarcode"
                            />
                        ) : (
                            <Translate className="font-size-0_75em" value="customRedlikeSettings.scanCanisterBarcode" />
                        )
                    ) : null}
                </div>
                {this.getBarcodeButtons(record)}
            </div>
        );
    };

    getTableRows = () => {
        return this.props.canisterList
            .filter((record) => record.colorant !== null)
            .map((record) => {
                let colorant = record.colorant;

                if (colorant.rgb === null) {
                    colorant = this.getColorantByCanister(record);
                }
                let rgb = this.getCanisterRgb(record, colorant);
                return modelHelper.buildTableRow(
                    [
                        modelHelper.buildTableCell(
                            <div className="flex-align-center-vertical flex">
                                <div
                                    className="color-square"
                                    style={{
                                        backgroundColor: rgb
                                    }}
                                />
                                <div>{record.colorant.name}</div>
                            </div>,
                            "font-size-1_75em"
                        ),
                        modelHelper.buildTableCell(record.colorant.id, "font-size-1_75em "),
                        modelHelper.buildTableCell(this.getBarcodeRowItem(record), "font-size-1_75em")
                    ],
                    (this.state.activeCanister === record.id &&
                    this.props.loggedUser.canEdit(resources.FUNCTION_SET_CANISTER_BARCODE)
                        ? "active padding-15"
                        : "padding-15") + " flex flex-align-center-vertical",
                    record.id,
                    {"data-key": record.id, onClick: this.handleTableItemClick}
                );
            });
    };

    getTableColumns = () => {
        return [
            modelHelper.buildTableColumn("col-3"),
            modelHelper.buildTableColumn("col-3"),
            modelHelper.buildTableColumn("col-6")
        ];
    };

    getCanistersContent = () => {
        if (this.props.canisterList.length === 0) {
            return "";
        }
        return modelHelper.buildModalSection(
            <Table
                variant={TABLE_VARIANT_SECONDARY}
                className="flex-child"
                tableHeader={this.getTableHeader()}
                tableRows={this.getTableRows()}
                tableColumns={this.getTableColumns()}
            />
        );
    };

    render() {
        if (!this.props.connected) {
            return (
                <Modal
                    tabId={this.props.tabId}
                    header={modelHelper.buildModalSection(
                        <Translate value="customRedlikeSettings.setCanisterBarcode" />
                    )}
                    content={modelHelper.buildModalSection(
                        <Translate className="font-size-1_5em" value="general.rccIsNotConnected" />,
                        "color-primary"
                    )}
                    onClose={this.handleCloseModalClick}
                    styles={{minWidth: "60%"}}
                />
            );
        }
        return (
            <Modal
                tabId={this.props.tabId}
                header={modelHelper.buildModalSection(<Translate value="customRedlikeSettings.setCanisterBarcode" />)}
                content={this.getCanistersContent()}
                styles={{minWidth: "60%"}}
                onClose={this.handleCloseModalClick}
            />
        );
    }
}
